import React from 'react'
import styled from 'styled-components'
import { useKeenSlider } from 'keen-slider/react'

const Container = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
  user-select: none;
  -webkit-touch-callout: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
  & .keen-slider__slide {
    position: relative;
    overflow: hidden;
    width: 100%;
    min-height: 100%;
  }
`
const Slider = ({ options, ...props }) => {
  const [sliderRef] = useKeenSlider(options)
  return <Container ref={sliderRef} {...props} />
}

export const SliderItem = ({ className = '', ...props }) => {
  return <div className={`keen-slider__slide ${className}`} {...props} />
}

export default Slider
